import { useGateValue } from '@statsig/react-bindings';

/** Sensor ↔ product links in the track drawer, detail page and edit drawer.
 * Targeted with "Environment Tier = staging or development" until prod release. */
export const SENSOR_PRODUCT_LINKS_GATE = 'sensor_product_links';

export function useSensorProductLinksGate(): boolean {
  return useGateValue(SENSOR_PRODUCT_LINKS_GATE);
}
